import React from 'react'

const EyeIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='17' height='18' viewBox='0 0 17 12' fill='none'>
      <path d='M1 8.74C1 4.46525 4.46525 1 8.74 1C13.0148 1 16.48 4.46525 16.48 8.74' stroke='#878787' strokeWidth='0.75' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M8.73979 11.5841C10.7648 11.5841 12.4063 9.9425 12.4063 7.91752C12.4063 5.89254 10.7648 4.25098 8.73979 4.25098C6.71481 4.25098 5.07324 5.89254 5.07324 7.91752C5.07324 9.9425 6.71481 11.5841 8.73979 11.5841Z' stroke='#878787' strokeWidth='0.75' strokeMiterlimit='10' />
    </svg>
  )
}

export default EyeIcon
